import { Navigate } from 'react-router-dom';
import { getSession } from '../services/session';
import SessionReload from './component-assets/SessionReload.jsx';
import { iAmHigherAuthority } from '../libs.jsx';
import BillingPage from '../pages/billing/BillingPage.jsx';

/**
 * Billing dispatcher — gates access by role_weight > 10 and renders the
 * V2 BillingPage. No V1 equivalent exists for this page.
 */
const Billing = () => {
  const dData = getSession();

  return iAmHigherAuthority(10, dData?.role_weight) ? (
    <>
      {dData?.migrated ? <SessionReload /> : null}
      <BillingPage />
    </>
  ) : <Navigate to="/" />;
};

export default Billing;
